// eslint-disable-next-line import/prefer-default-export
export const UNAVAILABLE_MESSAGE = 'Data Unavailable';
